document.addEventListener("DOMContentLoaded", function () {
	const logoCarousel = document.querySelector(".logo-carousel__swiper");

	if (logoCarousel) {
		const swiper = new Swiper(".logo-carousel__swiper", {
			// Optional parameters
			direction: "horizontal",
			loop: true,
			effect: "slide",
			autoplay: { delay: 5000 },
			speed: 1000,
			autoHeight: true,
			keyboard: true,
			slidesPerView: 5.5,
			centeredSlides: true,
			spaceBetween: 15,
			grabCursor: false,
			breakpoints: {
				1024: {
					slidesPerView: 4.5,
					spaceBetween: 30,
				},
				768: {
					slidesPerView: 3.5,
					spaceBetween: 30,
				},
				640: {
					slidesPerView: 2.5,
					spaceBetween: 15,
				},
				320: {
					slidesPerView: 1.75,
					spaceBetween: 10,
				},
			},

			// If we need pagination
			pagination: {
				el: ".swiper-pagination",
			},

			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}
});
